import { getFullName } from '@/helpers/string';
import { apiSdk } from '@/httpClient';
import { ChartOptions } from 'chart.js';
import React from 'react';
import { Line } from 'react-chartjs-2';
import { reportColors } from './config';
import { BookingSummaryOfTheYearReportItem } from '@/__generated';

type Props = {};
export const options: ChartOptions<'line'> = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: true,
    },
    title: {
      display: false,
    },

    tooltip: {
      position: 'nearest',
      mode: 'index',
      intersect: false,
      padding: 10,
      caretSize: 4,
      borderWidth: 2,
    },
  },
};
let labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
//
export default function SummaryCheckin({}: Props) {
  const [report, setReportDetail] = React.useState<BookingSummaryOfTheYearReportItem[]>();

  React.useEffect(() => {
    apiSdk.AgentBookingReportService.getBookingSummaryOfTheYear().then(res => {
      setReportDetail(res);
    });
  }, []);
  let data = React.useMemo(() => {
    if (report) {
      return {
        labels: labels,
        datasets: report.map((r, index) => ({
          label: getFullName(r.firstName, r.lastName),
          borderColor: reportColors[index],
          backgroundColor: reportColors[index],
          data: [r.noOfJan, r.noOfFeb, r.noOfMar, r.noOfApr, r.noOfMay, r.noOfJun, r.noOfJul, r.noOfAug, r.noOfSep, r.noOfOtc, r.noOfNov, r.noOfDec],
        })),
      };
    }
    return { labels: [], datasets: [] };
  }, [report]);

  return (
    <div className="col-12">
      <div className="py-30 px-30 rounded-4 bg-white shadow-3">
        <div className="d-flex justify-between items-center">
          <h2 className="text-18 lh-1 fw-500">Summary of the year {new Date().getFullYear()}</h2>
        </div>
        <div className="pt-20">
          <Line options={options} data={data} height={500} />
        </div>
      </div>
    </div>
  );
}
